"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisputeManager__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "disputeId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "enum DisputeManager.DisputeState",
                name: "state",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slashAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "returnAmount",
                type: "uint256",
            },
        ],
        name: "DisputeFinalized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "disputeId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "fisherman",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "enum DisputeManager.DisputeType",
                name: "_type",
                type: "uint8",
            },
        ],
        name: "DisputeOpen",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_indexer",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_deploymentId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_deposit",
                type: "uint256",
            },
            {
                internalType: "enum DisputeManager.DisputeType",
                name: "_type",
                type: "uint8",
            },
        ],
        name: "createDispute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "disputeIdByIndexer",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "disputes",
        outputs: [
            {
                internalType: "uint256",
                name: "disputeId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "address",
                name: "fisherman",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "depositAmount",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "enum DisputeManager.DisputeType",
                name: "dtype",
                type: "uint8",
            },
            {
                internalType: "enum DisputeManager.DisputeState",
                name: "state",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "disputeId",
                type: "uint256",
            },
            {
                internalType: "enum DisputeManager.DisputeState",
                name: "state",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "indexerSlashAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "newDeposit",
                type: "uint256",
            },
        ],
        name: "finalizeDispute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_minimumDeposit",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "isOnDispute",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minimumDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nextDisputeId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_minimumDeposit",
                type: "uint256",
            },
        ],
        name: "setMinimumDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settings",
        outputs: [
            {
                internalType: "contract ISettings",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class DisputeManager__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "DisputeManager";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.DisputeManager__factory = DisputeManager__factory;
DisputeManager__factory.bytecode = _bytecode;
DisputeManager__factory.abi = _abi;
